import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

const state = {
  socket: null,
  stompClient: null // 连接客户端
}

const mutations = {

}

const actions = {
  // 初始socket
  initSocket({ state }, url) {
    state.socket = new SockJS(url)
    state.stompClient = Stomp.over(state.socket)
  },
  // 连接
  connect({ state }, { headers }) {
    new Promise((resolve, reject) => {
      state.stompClient.connect(headers, () => {
        resolve()
      }, (err) => {
        reject(err)
      })
    })
  },
  // 订阅
  subscribe({ state }, url) {
    new Promise((resolve, reject) => {
      state.stompClient.subscribe(url, (msg) => {
        resolve(msg)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
